// Choice sets for TP Agent Radar (personal shortlists). Distinct from the club
// scout-request palette (constants/scoutRequestChoices.js): the prototype ships
// its OWN six-swatch label palette, so this is a separate map keyed by the
// backend colour enum (AgentRadarLabel.color: blue/red/amber/green/purple/pink)
// with the exact hex the design source uses. FE maps key → hex, mirroring the
// club side's "colour key stored, hex rendered" convention.

// The six swatches from the design source (New-label composer), in prototype order.
export const RADAR_LABEL_COLOR_ORDER = ["blue", "red", "amber", "green", "purple", "pink"];

export const RADAR_LABEL_COLORS = {
  blue: "#2283FF",
  red: "#EF4444",
  amber: "#F59E0B",
  green: "#10B981",
  purple: "#8B5CF6",
  pink: "#EC4899",
};

// key → hex with a safe fallback (blue) for any unknown token.
export const radarLabelHex = (key) => RADAR_LABEL_COLORS[key] || RADAR_LABEL_COLORS.blue;

// Position filter options for the entries pane. `all` = no filter; the rest mirror
// the design's short position tokens. Values are compared against the entry's
// resolved short position (see radarShortPosition in radarFormat).
export const RADAR_POSITION_OPTIONS = [
  { value: "all", label: "All positions" },
  { value: "GK", label: "GK" },
  { value: "LB", label: "LB" },
  { value: "CB", label: "CB" },
  { value: "RB", label: "RB" },
  { value: "DM", label: "DM" },
  { value: "CM", label: "CM" },
  { value: "AM", label: "AM" },
  { value: "LW", label: "LW" },
  { value: "RW", label: "RW" },
  { value: "ST", label: "ST" },
];

// Sort options — values are the ones agentRadarService sends as `?sort=`.
export const RADAR_SORT_OPTIONS = [
  { value: "recent", label: "Recently added" },
  { value: "name", label: "Name A–Z" },
  { value: "contract", label: "Contract expiry" },
];
